import(/* webpackMode: "eager" */ "/vercel/path0/src/app/data-retention/page.tsx");
